import React from "react";
import BankListPagePresenter from "./BankListPagePresenter";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";
import withRouter from "../../../withRouter.js";
import { InfiniteScroll } from "../../../nq-component";
import CustomLoader from "../../../components/CustomLoader";
import PageHeader from "../../../components/PageHeader/index.js";
import SearchFilterCard from "../../../components/SearchFilterCard/index.js";
import AddButton from "../../../components/AddButton/index.js";
import BankCards from "../../../components/BankCards/index.js";

class BankListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
    };
    this.presenter = new BankListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
      getObjectUseCase(),
    );
  }

  getCollectionName() {
    return "banks";
  }

  getClientId() {
    return this.props.params.id;
  }

  onFilter() {
    this.presenter.init();
    this.presenter.getObjects();
  }

  onChange(value, field) {
    this.setState(value);
  }

  onClickAdd() {
    this.navigateTo("/bank-account/form");
  }

  onEdit(id) {
    this.navigateTo(`/bank-account/form/${id}`);
  }

  render() {
    const { progress, objects } = this.state;
    const user = this.getCurrentUser();
    const isAdmin = this.isAdmin();

    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();

    return (
      <>
        <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
          <div className="d-flex flex-column gap-4">
            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Bank Accounts" },
              ]}
              title={"Bank Accounts"}
              backButton={isAdmin}
              description="Manage and view all your linked bank accounts"
            />

            <SearchFilterCard
              schema={schema}
              schemas={schemas}
              onSearch={this.searchSubmit.bind(this)}
              searchFields={{
                name: { type: "String" },
              }}
              onFilter={this.onChangeFilter.bind(this)}
            />

            {progress ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "400px",
                  padding: "3rem",
                }}
              >
                <CustomLoader />
              </div>
            ) : (
              <div className="d-flex flex-column">
                <BankCards
                  editable
                  className={"bg-transparent"}
                  objects={objects}
                  onEdit={this.onEdit.bind(this)}
                />
              </div>
            )}
          </div>
          <AddButton onClick={this.onClickAdd.bind(this)} show={true} />
        </InfiniteScroll>
      </>
    );
  }
}

export default withRouter(BankListPage);
